import React from 'react';

import Tabs from '../../../../components/Tabs';
import CategoryDetailTab from '../CategoryDetailTab';
import CategoryProductListTab from '../CategoryProductListTab';
import { CategoryBannerTab } from '../CategoryBannerTab';
import useToastMsg from '../../../../hooks/common/useToastMsg';
import { useCurrentTab } from '../../../../hooks/common/useCurrentTab';
import useCategoryDetail from './useCategoryDetail';
import categoryToastMsg from '../../../../constants/service/toastMsg/categoryToastMsg';
import { GET_CATEGORY_DETAIL_INITIAL_DATA } from '../constants';
import './CategoryDetailWrap.scss';

const CategoryDetailWrap = () => {
  const { currentTabKey, setTabKey } = useCurrentTab();
  const { success, error } = useToastMsg();

  const { data } = useCategoryDetail({
    placeholderData: GET_CATEGORY_DETAIL_INITIAL_DATA,
    onSuccess: () => success(categoryToastMsg.GET_CATEGORY_DETAIL_REQUEST_SUCCESS),
    onError: (e: any) => error(categoryToastMsg.GET_CATEGORY_DETAIL_REQUEST_ERROR, e),
  });

  if (!data) return null;
  const { category } = data;

  const tabList = [
    { title: '상세 정보', content: <CategoryDetailTab category={category} /> },
    { title: '상품 리스트', content: <CategoryProductListTab /> },
    ...(category.parentId === null
      ? [{ title: '배너 관리', content: <CategoryBannerTab /> }]
      : []),
  ];

  const parsedTabKey = Number(currentTabKey);
  const isValidTabKey =
    Number.isInteger(parsedTabKey) && parsedTabKey >= 0 && parsedTabKey < tabList.length;
  const safeTabKey = isValidTabKey ? String(parsedTabKey) : '0';

  return (
    <div className="category-detail-wrap">
      <div className="category-detail-title">
        <span>{category.name}</span> 카테고리 상세정보
      </div>
      <Tabs
        activeKey={safeTabKey}
        onChange={(tabKey: any) => setTabKey(tabKey)}
        list={tabList}
      />
    </div>
  );
};

export default CategoryDetailWrap;
